import Typography from '@material-ui/core/Typography';
import VocabularyManagerIcon from '../../core/icons/VocabularyManager';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';

class ProjectLink extends React.Component {

    render() {

        const { data, defaultLang, id, locked } = this.props;

        return (
            <Typography data-test="project-link"
                variant="caption"
                style={{
                    overflow: 'hidden',
                    display: 'inline-block',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>
                <VocabularyManagerIcon fontSize="small" fill="#808080" style={{ verticalAlign: 'bottom', marginRight: 4 }} />
                {data.title && data.title[defaultLang] ? data.title[defaultLang] : id}
                {locked && <span data-test="locked"> (This project is currently locked)</span>}
            </Typography>
        );
    }
}

ProjectLink.propTypes = {
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    locked: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};

export default withGS(ProjectLink, ["ALL"], ["id", "title", "hasEntitlement"], { predicates: ["http://purl.org/dc/terms/title"] });